import { mapping } from "#vuepal-build/route-queries";
import {
  useAsyncGraphqlQuery,
  useRoute,
  useDrupalRoute,
  createError
} from "#imports";
export async function useDrupalRouteQuery(name, options) {
  const route = useRoute();
  const queryName = mapping[name];
  const { data } = await useAsyncGraphqlQuery(
    queryName,
    {
      path: route.path
    },
    {
      transform: function(data2) {
        return data2.data;
      },
      graphqlCaching: {
        client: options?.clientCache ?? true
      },
      deep: false
    }
  );
  const ctx = await useDrupalRoute(data.value, null, route);
  if (data.value && "route" in data.value && !["EntityCanonicalUrl", "DefaultEntityUrl"].includes(
    data.value.route?.__typename
  )) {
    throw createError({
      statusCode: 404,
      statusMessage: "Page not found",
      fatal: true
    });
  }
  return ctx;
}
